import filters from './filters'
import { fsDomain, configUrl } from '@/lib/configUrl'
import { getPublicKey } from '@/api/modules/accountCenter'

export default {
  // 获取申诉结果、当前状态
  getMerchantDealStatusLabel: filters.getMerchantDealStatusLabel,
  // 获取拒付原因
  getChineseReason: filters.getChineseReason,
  // 获取拒付进度中文描述
  getChargebackType: filters.getChargebackType,
  dateNormalTime: filters.dateNormalTime,
  toDate: filters.date,
  // 路由跳转
  $jump(to, name, _params) {
    const router = this.$router
    router && router.push(to)
  },

  // 路由跳转 无历史记录
  $replace(to) {
    const router = this.$router
    router && router.replace(to)
  },
  // 多页面跳转
  $href(to, query) {
    const loc = window.location
    let url = to
    url = query ? url + '?' + query : url
    loc.href = url
  },
  // 新标签 to为路由地址，query为url传参，win为在请求前创建的window.open()防止浏览器拦截
  $open(to, query, win) {
    const local = window.location
    const origin = local.origin
    let url = origin + '/#' + to
    url = query ? url + '?' + query : url
    win ? (win.location.href = url) : window.open(url)
  },
  // 新标签 to为路由地址，query为url传参，win为在请求前创建的window.open()防止浏览器拦截
  $openHref(url, win) {
    win ? (win.location.href = url) : window.open(url)
  },
  // 全局提示错误 依赖ppui的message组件
  $showError(err = '请检查网络连接是否正确') {
    this.$message.error(err)
  },
  // 传入文件流，下载excel文件
  $bufferToFile(data, fileName, type = 'application/vnd.ms-excel') {
    const blob = new Blob([data], {
      type: type
    })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('id', 'downloadLink')
    link.setAttribute('download', `${fileName}`)
    document.body.appendChild(link)
    link.click()
    // 删除添加的a链接
    const objLink = document.getElementById('downloadLink')
    document.body.removeChild(objLink)
    // 释放内存
    // window.URL.revokeOjbectURL(url);
  },
  getCookie(name) {
    var arr
    var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    if ((arr = document.cookie.match(reg))) { return encodeURIComponent(unescape(arr[2])) } else {
      return null
    }
  },
  // 获取图片服务域名
  getEnv() {
    return fsDomain || 'https://acquirer-fs-fra.pingpongx.com'
  },

  fetchImg(fileName) {
    var key = this.getCookie('fs_merchant')
    var url =
            this.getEnv() + '/file/eu/load/' + fileName + '?app=merchant&key=' + key
    return url
  },
  getQueryString(name) {
    const link = decodeURIComponent(window.location.search)
    var vars = link.substring(1).split('&')
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=')
      if (pair[0] == name) {
        return pair[1]
      }
    }
    return null
  },
  isEmojiCharacter(substring) {
    for (var i = 0; i < substring.length; i++) {
      var hs = substring.charCodeAt(i)
      if (hs >= 0xd800 && hs <= 0xdbff) {
        if (substring.length > 1) {
          var ls = substring.charCodeAt(i + 1)
          var uc = (hs - 0xd800) * 0x400 + (ls - 0xdc00) + 0x10000
          if (uc >= 0x1d000 && uc <= 0x1f77f) {
            return true
          }
        }
      } else if (substring.length > 1) {
        var ls = substring.charCodeAt(i + 1)
        if (ls == 0x20e3) {
          return true
        }
      } else {
        if (hs >= 0x2100 && hs <= 0x27ff) {
          return true
        } else if (hs >= 0x2b05 && hs <= 0x2b07) {
          return true
        } else if (hs >= 0x2934 && hs <= 0x2935) {
          return true
        } else if (hs >= 0x3297 && hs <= 0x3299) {
          return true
        } else if (
          hs == 0xa9 ||
                    hs == 0xae ||
                    hs == 0x303d ||
                    hs == 0x3030 ||
                    hs == 0x2b55 ||
                    hs == 0x2b1c ||
                    hs == 0x2b1b ||
                    hs == 0x2b50
        ) {
          return true
        }
      }
    }
  },

  getTimeZone() {
    const timeZone = new Date().getTimezoneOffset() / 60
    // UTC+8
    if (timeZone > 0) {
      this.timeZone = `UTC-${Math.abs(timeZone)}`
    } else if (timeZone < 0) {
      this.timeZone = `UTC+${Math.abs(timeZone)}`
    } else {
      this.timeZone = 'UTC+0'
    }

    return this.timeZone
  },

  // 获取服务器公钥
  async getPublicKey() {
    return await getPublicKey()
  },

  // 获取最近7天
  $getCurrentWeek() {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    return [this.toDate(start), this.toDate(end)]
  },

  getMerchantFilesUrl() {
    return `${configUrl}/merchant/acquirer/file`
  },
}
